import { useEffect } from "react";
import { Sigle, useBranding } from "../branding";
import { useAuthenticatedSession } from "../session";
import { AppLayout } from "./AppLayout";
import styles from "./AppLayout.module.css";
import { NAV_CONSULTANT } from "./routes";

/**
 * L'espace d'un consultant : ses missions et ses feuilles de temps.
 *
 * Pas de `WalletProvider` dessous, et ce n'est pas un oubli : aucun écran de
 * cet espace ne lit un portefeuille, un tarif ou un montant. Un écran métier
 * qu'on monterait ici par erreur casserait au premier `useWalletScope()`,
 * plutôt que d'afficher à un consultant ce qu'il ne doit pas voir.
 */
export function ConsultantLayout() {
  const { user } = useAuthenticatedSession();
  const { product_short } = useBranding();

  useEffect(() => {
    const avant = document.title;
    document.title = `Mes feuilles de temps · ${product_short}`;
    return () => {
      document.title = avant;
    };
  }, [product_short]);

  return (
    <AppLayout
      navItems={NAV_CONSULTANT}
      brand={
        <>
          <Sigle />
          <span className={styles.nomProduit}>
            <strong>Espace consultant</strong>
            <span>{user.email}</span>
          </span>
        </>
      }
    />
  );
}
